import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type ShopIndicatorPayload = { is_shop: boolean; is_shop_color: string };

export const useAppointmentShopIndicatorMutation = (appointment_id: number) =>
  useTypedMutation<ShopIndicatorPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/appointments/update_shopping_cart", { appointment_id, ...payload });
    },
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, ...payload });
    }
  });
